// skipcq: JS-W1028
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';

import { elevatedPaperSurface } from '../../utils/vintageSurfaces';

import { PORTFOLIO_SORT_OPTIONS } from '../../utils/brewhousePortfolio/portfolioBeerSort';
import { PORTFOLIO_STYLE_FILTER_ALL } from '../../utils/brewhousePortfolio/portfolioStyleFilters';

function PintPortfolioFilterSortSheet({
  open,
  onClose,
  onOpen,
  sortMode,
  onSortChange,
  styleCategory,
  onStyleCategoryChange,
  styleCategories,
  styleName,
  onStyleNameChange,
  styleNames,
}) {
  const theme = useTheme();

  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      disableSwipeToOpen
      PaperProps={{
        sx: {
          ...elevatedPaperSurface(theme.palette.background.paper),
          color: theme.palette.text.primary,
          // Override global MuiDrawer sidebar texture; keep a light parchment wash only.
          backgroundImage: `linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.3) 0%,
            rgba(255, 255, 255, 0.1) 70%,
            rgba(42, 35, 25, 0.06) 100%
          )`,
          backgroundSize: 'auto',
          backgroundBlendMode: 'normal',
          borderTopLeftRadius: 12,
          borderTopRightRadius: 12,
          px: 2,
          pb: 3,
        },
      }}
    >
      <Box sx={{ py: 2 }}>
        <Typography variant="h6" component="h2" gutterBottom>
          Filter &amp; sort
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
          <FormControl fullWidth size="small">
            <InputLabel id="pint-portfolio-sheet-sort-label">Sort</InputLabel>
            <Select
              labelId="pint-portfolio-sheet-sort-label"
              value={sortMode}
              label="Sort"
              onChange={onSortChange}
            >
              {PORTFOLIO_SORT_OPTIONS.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth size="small">
            <InputLabel id="pint-portfolio-sheet-category-label">Style Category</InputLabel>
            <Select
              labelId="pint-portfolio-sheet-category-label"
              value={styleCategory}
              label="Style Category"
              onChange={onStyleCategoryChange}
            >
              <MenuItem value={PORTFOLIO_STYLE_FILTER_ALL}>All categories</MenuItem>
              {styleCategories.map((category) => (
                <MenuItem key={category} value={category}>
                  {category}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth size="small">
            <InputLabel id="pint-portfolio-sheet-name-label">Style Name</InputLabel>
            <Select
              labelId="pint-portfolio-sheet-name-label"
              value={styleName}
              label="Style Name"
              onChange={onStyleNameChange}
            >
              <MenuItem value={PORTFOLIO_STYLE_FILTER_ALL}>All styles</MenuItem>
              {styleNames.map((name) => (
                <MenuItem key={name} value={name}>
                  {name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Box>
    </SwipeableDrawer>
  );
}

PintPortfolioFilterSortSheet.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onOpen: PropTypes.func.isRequired,
  sortMode: PropTypes.string.isRequired,
  onSortChange: PropTypes.func.isRequired,
  styleCategory: PropTypes.string.isRequired,
  onStyleCategoryChange: PropTypes.func.isRequired,
  styleCategories: PropTypes.arrayOf(PropTypes.string).isRequired,
  styleName: PropTypes.string.isRequired,
  onStyleNameChange: PropTypes.func.isRequired,
  styleNames: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default PintPortfolioFilterSortSheet;
